import React from "react";
import { useProviderComparePageContext } from "../Context";
import { LoadingIndicator } from "../LoadingIndicator";
import { useCategoryMetaContext } from "../Context/CategoryMetaContext";
import { CategoryDisplay } from "../Container";

export const ProviderCompareReportWithContext = () => {
    const { loading: providerLoading, toProviderLoading } = useProviderComparePageContext();

    const { categoryLoading, roots } = useCategoryMetaContext();

    const loading = providerLoading || toProviderLoading || categoryLoading;
    return (
        <div className="col-12">
            {loading && <LoadingIndicator />}

            <CategoryDisplay categories={roots} />
        </div>
    );
};
